module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-14.fd8bea5e.jpg";